<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="{ ...on }"
             @click.stop.prevent="emitChange">
        <v-icon :color="iconColor">mdi-filter-outline</v-icon>
      </v-btn>
    </template>
    <span>Filtrar por produtos ativos</span>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('listagemProdutos', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    onlyAtivos: {
      get() {
        return this.$store.getters['listagemProdutos/onlyAtivos'];
      },
      set(onlyAtivos) {
        this.$store.dispatch('listagemProdutos/onlyAtivos', onlyAtivos);
      },
    },
  },
  methods: {
    emitChange() {
      this.onlyAtivos = !this.onlyAtivos;
      this.$emit('change');
    },
  },
  created() {
    this.onlyAtivos = this.onlyAtivos || false;
  },
};
</script>
